import { render, staticRenderFns } from "./mod-mobile-demo.vue?vue&type=template&id=21d84b61&"
import script from "./mod-mobile-demo.vue?vue&type=script&lang=js&"
export * from "./mod-mobile-demo.vue?vue&type=script&lang=js&"
import style0 from "./mod-mobile-demo.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports